import { ITrendingBlogResponse } from "@/types/trending-blog.type";
import { BASE_URL, STRAPI_HEADERS } from "./strapi-config";

export const getTrendingBlogs = (
  locale: string
): Promise<ITrendingBlogResponse> => {
  return fetch(
    `${BASE_URL}/trending-blogs?locale=${encodeURIComponent(locale)}&populate[0]=blog&populate[1]=blog.poster&sort[0]=priority_order`,
    STRAPI_HEADERS
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: ITrendingBlogResponse) => {
      return data;
    });
};
